/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";
import { FieldWrapper } from "../FieldWrapper";
import { Button, IButtonProps, Icon } from "../../core";

import "./FieldButton.scss";

export interface IFieldButtonProps extends IButtonProps {
	children?: React.ReactNode;
	icon?: string;
	className?: string;
	tooltip?: string;
	readOnly?: boolean;
}

const FieldButton: React.FC<IFieldButtonProps> = ({ children, className, icon, ...props }) => {
	const baseClass = BEM("edt-field-button");

	if (className) {
		baseClass.add(className);
	}

	return (
		<FieldWrapper type="button" className={baseClass.toClassName()}>
			<Button
				startIcon={icon && <Icon className={baseClass.element("icon").toClassName()} name={icon} />}
				{...props}
			>
				{children}
			</Button>
		</FieldWrapper>
	);
};

const FieldButtonMemo = React.memo(FieldButton);

export { FieldButtonMemo as FieldButton };
